import React, { Component } from 'react';
import Profile from './Profile';

const defaultDistance = '15px';
export default class Hero extends Component {
    constructor(props) {
        super(props);
        this.state = { expanded: false };
    }

    renderQuickInfo = () => {
        return (
            <div
                style={{
                    position: 'absolute',
                    bottom: defaultDistance,
                    left: defaultDistance,
                    zIndex: 10,
                    height: 40
                }}
            >
                <div>Jeremy Danner, 24</div>
                <div style={{ fontWeight: 100, marginTop: '5px' }}>Elicit AB, Göteborg</div>
            </div>
        );
    };

    openProfile = () => {
        this.props.openProfile();
        this.props.action();
    };

    renderProfile() {
        if (window.innerHeight >= 660) {
            return (
                <div
                    style={{
                        padding: `0 ${defaultDistance}`,
                        height: 60,
                        overflow: 'hidden'
                    }}
                >
                    <Profile hideTop={true} />
                </div>
            );
        }
        return null;
    }

    renderInfo = () => {
        return (
            <div style={{ color: '#000000', background: '#ffffff' }}>
                <div style={{ padding: `5px ${defaultDistance}` }}>
                    <div style={{ fontWeight: 'bold', fontSize: 16 }}>Jeremy Danner, 24</div>
                    <div>
                        <span role="img" aria-label="emoji">
                            💼
                        </span>{' '}
                        Systemutvecklare,{' '}
                        <a rel="noopener noreferrer" href="https://www.elicit.se" target="_blank">
                            Elicit AB
                        </a>
                    </div>
                    <div>
                        <span role="img" aria-label="emoji">
                            📱
                        </span>{' '}
                        <a href="tel:+46762281885">+46 762 28 18 85</a>
                    </div>
                    <div>
                        <span role="img" aria-label="emoji">
                            ✉️
                        </span>{' '}
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="mailto:jeremydanner2@gmail.com?Subject=Tänk%20på%20att%20jag%20är%20nöjd%20med%20mitt%20jobb%20som%20jag%20har%20idag,%20du%20måste%20locka%20med%20något%20riktigt%20bra%20i%20så%20fall!%20😅"
                        >
                            jeremydanner2@gmail.com
                        </a>
                    </div>
                </div>
                <hr />

                {this.renderProfile()}

                <div
                    className="pointer"
                    onClick={() => this.openProfile()}
                    style={{ padding: '5px 0', textAlign: 'center', textDecoration: 'underline' }}
                >
                    Vill du veta mer? Läs min profil{' '}
                    <span role="img" aria-label="emoji">
                        👉{' '}
                    </span>
                    <img
                        alt="account"
                        style={{ width: 20, height: 'auto' }}
                        src={require('../images/account.png')}
                    />
                </div>
            </div>
        );
    };

    handelExpandation = async () => {
        await this.props.action();
        await this.setState({ expanded: !this.state.expanded });
    };

    dragTask(event) {
        if (event.touches[0].clientX >= 350) {
            return this.props.isMatch();
        }
        if (event.touches[0].clientX <= 50) {
            return alert('Synd att det inte var en match 😢');
        }
        if (event.touches[0].clientY <= 80) {
            alert('SUPER LIKE! 😎');
            return this.props.isMatch();
        }
    }
    isMatch = () => {
        if (!this.state.expanded) {
            this.props.isMatch();
        }
        return;
    };

    render() {
        return (
            <div>
                <div
                    draggable="true"
                    onTouchMove={event => {
                        this.dragTask(event);
                    }}
                    onDragEnd={event => {
                        this.isMatch();
                    }}
                    style={{ margin: this.state.expanded ? 0 : '10px' }}
                    className="hero-container"
                >
                    <img
                        style={{
                            borderRadius: this.state.expanded ? 0 : '7px',
                            boxShadow: this.state.expanded ? 'none' : null
                        }}
                        className="hero"
                        src={require('../images/profile.png')}
                        alt="profil bild"
                    />
                    <div
                        onClick={() => this.handelExpandation()}
                        style={{
                            position: 'absolute',
                            bottom: this.state.expanded ? '0' : defaultDistance,
                            right: defaultDistance,
                            zIndex: 10,
                            height: 40,
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        <img
                            className="pointer"
                            style={{
                                width: 25,
                                height: 'auto',
                                opacity: this.state.expanded ? 0.4 : 1,
                                border: this.state.expanded ? '1px solid #ffffff' : 'none',
                                borderRadius: '50%',
                                background: this.state.expanded ? '#ffffff' : null
                            }}
                            alt="info"
                            src={require(this.state.expanded
                                ? '../images/nope.png'
                                : '../images/info.png')}
                        />
                    </div>

                    {this.state.expanded ? null : this.renderQuickInfo()}
                </div>
                {this.state.expanded ? this.renderInfo() : null}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Hero.js